import { QueryableTextAndResultsAnnotationEntry } from '@scale/shared/types/response/textcollection';
import { makeStyles } from 'react-scale/components/design-system';
import _ from 'lodash';

interface QueryableTextAndResultsFieldSectionPreviewProps {
  response: QueryableTextAndResultsAnnotationEntry;
}

export const QueryableTextAndResultsFieldSectionPreview = ({
  response,
}: QueryableTextAndResultsFieldSectionPreviewProps) => {
  const styles = useStyles();
  const firstEntry = _.first(response?.searchResults);
  const defaultResult =
    !_.isNil(firstEntry) && _.isNil(firstEntry.title) ? firstEntry.snippet : null;
  const searchTerm = response?.searchTerm;
  return (
    <span className={styles.queryableTextAndResults}>
      <div>{searchTerm && `Query: ${searchTerm}`}</div>
      <div>{defaultResult && `Default Result: ${defaultResult}`}</div>
    </span>
  );
};

const useStyles = makeStyles({
  queryableTextAndResults: {
    marginTop: 4,
    display: 'flex',
    flexDirection: 'column',
    color: '#000000',
    gap: 2,
  },
});
